import { hasPermission, type Permission } from "@shared/contracts/permissions";

export function userHasPermission(
  permissions: readonly Permission[] | undefined | null,
  permission: Permission,
) {
  if (!permissions || permissions.length === 0) return false;
  return hasPermission(permissions, permission);
}
